var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Process"},[_c('Header',{attrs:{"msg":"报读流程"}}),_c('img',{staticClass:"Process-img",attrs:{"src":require("@/assets/mine/bg_pay@3x.png")}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }